import React, { useCallback, useEffect, useMemo, useState } from "react";
import ExportCSVModal from "../../Components/Common/ExportCSVModal";
import DeleteModal from "../../Components/Common/DeleteModal";
import {
    Button,
    Card,
    CardHeader,
    Col,
    Container,
    Form,
    FormFeedback,
    Input,
    Label,
    Modal,
    ModalBody, ModalFooter,
    ModalHeader,
    Row, Spinner
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";
import Loader from "../../Components/Common/Loader";
import Flatpickr from "react-flatpickr";
import { toast, ToastContainer } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
    addNewTopicArea as onAddNewTopicArea,
    addTopicAreaTranslation as onAddTopicAreaTranslation,
    deleteTopicArea as onDeleteTopicArea,
    getTopicAreas as onGetTopicAreas,
    updateTopicArea as onUpdateTopicArea
} from "../../slices/topicArea/thunk";

import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import AuthorizeForAction from "../../Routes/AuthorizeForAction";

const TopicArea = () => {

    const dispatch = useDispatch();
    const [isEdit, setIsEdit] = useState(false);
    const [modal, setModal] = useState(false);
    const [translationModal, setTranslationModal] = useState(false);
    const [topicArea, setTopicArea] = useState([]);
    const [lang, setLang] = useState([]);
    const [courseTranslation, setCourseTranslation] = useState([]);
    const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
    const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = useState(false);
    const [defualtTranslation, setdefualtTranslation] = useState("");
    const [transFullname, setTransFullname] = useState("");
    const [transLang, setTransLang] = useState("");

    const [loading, setLoading] = useState(true);
    const [isloading, setIsloading] = useState(false);

    const selectLayoutState = (state) => state.TopicArea;
    const topicAreaProperties = createSelector(
        selectLayoutState,
        (ecom) => ({
            topicAreas: ecom.topicAreas,
            langs: ecom.langs,
            isTopicAreaSuccess: ecom.isTopicAreaSuccess,
            isTopicAreaCreated: ecom.isTopicAreaCreated,
            error: ecom.error,
        })
    );
    // Inside your component
    const {
        topicAreas, langs, isTopicAreaSuccess, error, isTopicAreaCreated
    } = useSelector(topicAreaProperties)


    const toggle = useCallback(() => {
        if (modal) {
            setModal(false);

        } else {
            setModal(true);
        }
    }, [modal]);

    useEffect(() => {
        if (topicAreas && !topicAreas.length) {
            dispatch(onGetTopicAreas());
        }
    }, [dispatch]);


    useEffect(() => {
        setTopicArea(topicAreas);
        setLang(langs);
        setLoading(!isTopicAreaSuccess);
        if (isTopicAreaCreated) {
            setIsloading(false);
            validation.resetForm();
            setModal(false);
            validationTrans.resetForm();
            setTranslationModal(false);
        }
        if (error) {
            setIsloading(false);
        }
    }, [topicAreas, langs, isTopicAreaCreated, isTopicAreaSuccess, error]);

    useEffect(() => {
        if (!isEmpty(topicAreas)) {
            setTopicArea(topicAreas);
            setLang(langs);
            setLoading(!isTopicAreaSuccess);
            setIsEdit(false);
        }
    }, [topicAreas, langs, isTopicAreaCreated, isTopicAreaSuccess]);


    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            full_name: (isEdit ? (topicArea && topicArea.full_name) : "") || '',
            status: (isEdit ? (topicArea && topicArea.status) : "") || '',
        },
        validationSchema: Yup.object({
            full_name: Yup.string().required("Please Enter Title"),
            status: Yup.string().required("Please Enter Your Status")
        }),
        onSubmit: (values) => {
            setIsloading(true);
            if (isEdit) {
                const updateTopicArea = {
                    id: topicArea ? topicArea.id : 0,
                    full_name: values.full_name,
                    status: values.status,
                };
                dispatch(onUpdateTopicArea(updateTopicArea));
            } else {
                const newTopicArea = {
                    full_name: values["full_name"],
                    status: values["status"]
                };
                dispatch(onAddNewTopicArea(newTopicArea));
            }
        },
    });

    const validationTrans = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            t_topic_area_id: (topicArea && topicArea.id) || '',
            t_full_name: (transFullname && transFullname) || '',
            t_lang: (lang.map(item => item.lang_short)) || '',
        },
        validationSchema: Yup.object({
        }),
        onSubmit: (values) => {
            setIsloading(true);
            const newTopicAreaTrans = {
                topic_area_id: values["t_topic_area_id"],
                full_name: values["t_full_name"],
                lang: values["t_lang"]
            };
            dispatch(onAddTopicAreaTranslation(newTopicAreaTrans));
        },
    });

    const courseStatus = [
        {
            options: [
                { label: "Select Status", value: " " },
                { label: "Active", value: "1" },
                { label: "In-Active", value: "2" },
            ],
        },
    ];

    const handleCustomerClick = useCallback((arg) => {
        const topicArea = arg;
        setTopicArea({
            id: topicArea.id,
            full_name: topicArea.topic_area_translation[0].full_name,
            status: topicArea.status
        });
        setIsEdit(true);
        toggle();
    }, [toggle]);

    const checkedAll = useCallback(() => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        } else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
        deleteCheckbox();
    }, []);

    const deleteCheckbox = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
        setSelectedCheckBoxDelete(ele);
    };

    const columns = useMemo(
        () => [
            {
                Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
                Cell: (cellProps) => {
                    return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id} onChange={() => deleteCheckbox()} />;
                },
                id: '#',

            },
            {
                Header: "Topic Area",
                accessor: "topic_area_translation[0].full_name",
                filterable: false,
            },
            {
                Header: "No of Questions",
                accessor: "questions_count",
                filterable: false,
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: (cell) => {
                    switch (cell.value) {
                        case 1:
                            return <span className="badge text-uppercase bg-success-subtle text-success"> {cell.value == 1 ? "Active" : ""} </span>;
                        case 2:
                            return <span className="badge text-uppercase bg-danger-subtle text-danger"> {cell.value == 2 ? "In-Active" : ""} </span>;
                        default:
                            return <span className="badge text-uppercase bg-info-subtle text-info"> {cell.value == 2 ? "In-Active" : "Active"} </span>;
                    }
                }
            },
            {
                Header: "Action",
                Cell: (cellProps) => {
                    return (
                        <ul className="list-inline hstack gap-2 mb-0">
                            <AuthorizeForAction requiredPermissions={['topic-edit']}>
                                <li className="list-inline-item edit" title="Edit">
                                    <Link
                                        to="#"
                                        className="text-primary d-inline-block edit-item-btn"
                                        onClick={() => { const customerData = cellProps.row.original; handleCustomerClick(customerData); }}
                                    >
                                        <i className="ri-pencil-fill fs-16"></i>
                                    </Link>
                                </li>
                            </AuthorizeForAction>
                            <AuthorizeForAction requiredPermissions={['topic-delete']}>
                                <li className="list-inline-item" title="Remove">
                                    <Link
                                        to="#"
                                        className="text-danger d-inline-block remove-item-btn"
                                        onClick={() => { const customerData = cellProps.row.original; onClickDelete(customerData); }}
                                    >
                                        <i className="ri-delete-bin-5-fill fs-16"></i>
                                    </Link>
                                </li>
                            </AuthorizeForAction>
                            <AuthorizeForAction requiredPermissions={['topic-translate']}>
                                <li className="list-inline-item" title="Translation">
                                    <Link
                                        to="#"
                                        className="text-success d-inline-block translate-item-btn"
                                        onClick={() => { const customerData = cellProps.row.original; onClickTranslate(customerData); }}
                                    >
                                        <i className="ri-translate fs-18"></i>
                                    </Link>
                                </li>
                            </AuthorizeForAction>
                        </ul>
                    );
                },
            },

        ],
        [handleCustomerClick, checkedAll]
    );

    const onClickDelete = (topicArea) => {
        setTopicArea(topicArea);
        setDeleteModal(true);
    };

    const onClickTranslate = (customerData) => {
        setActiveIndex(0);
        setTopicArea(customerData);
        setdefualtTranslation(customerData.topic_area_translation[0]);
        setCourseTranslation(customerData.topic_area_translation);
        setTransFullname(customerData.topic_area_translation.map(item => item.full_name));
        setTransLang(customerData.topic_area_translation.map(item => item.lang));
        setTranslationModal(true);
    };

    const deleteMultiple = () => {
        const checkall = document.getElementById("checkBoxAll");
        selectedCheckBoxDelete.forEach((element) => {
            dispatch(onDeleteTopicArea(element.value));
            setTimeout(() => { toast.clearWaitingQueue(); }, 3000);
        });
        setIsMultiDeleteButton(false);
        checkall.checked = false;
    };

    const handleCustomerClicks = () => {
        setTopicArea("");
        setIsEdit(false);
        toggle();
    };

    const handleDeleteCustomer = () => {
        if (topicArea) {
            dispatch(onDeleteTopicArea(topicArea.id));
            setDeleteModal(false);
        }
    };

    const [activeIndex, setActiveIndex] = useState(0);
    const [inputValue, setInputValue] = useState('');

    const handleTabClick = (index) => {
        setActiveIndex(index);
    };
    
    const handleInputChange = (index, value) => {
        const newArray = [...transFullname]; // Create a copy of the array
        newArray[index] = value; // Update the value at the specified index
        setTransFullname(newArray); // Update the state with the new array
    };

    document.title = "Topic Areas | Theory Practice";
    return (
        <React.Fragment>
            <div className="page-content">
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={handleDeleteCustomer}
                    onCloseClick={() => setDeleteModal(false)}
                />
                <DeleteModal
                    show={deleteModalMulti}
                    onDeleteClick={() => {
                        deleteMultiple();
                        setDeleteModalMulti(false);
                    }}
                    onCloseClick={() => setDeleteModalMulti(false)}
                />
                <Container fluid>
                    <BreadCrumb title="Topic Areas List" pageTitle="Dashboard" />
                    <Row>
                        <Col lg={12}>
                            <Card id="customerList">
                                <CardHeader className="border-0">
                                    <Row className="g-4 align-items-center">
                                        <div className="col-sm">
                                            <div>
                                                <h5 className="card-title mb-0">Topic Areas List</h5>
                                            </div>
                                        </div>
                                        <div className="col-sm-auto">
                                            <div>
                                                <AuthorizeForAction requiredPermissions={['topic-delete']}>
                                                    {isMultiDeleteButton && <button className="btn btn-soft-danger me-1"
                                                        onClick={() => setDeleteModalMulti(true)}
                                                    ><i className="ri-delete-bin-2-line"></i></button>}
                                                </AuthorizeForAction>
                                                <AuthorizeForAction requiredPermissions={['topic-create']}>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success add-btn"
                                                        id="create-btn"
                                                        onClick={() => { setIsEdit(false); toggle(); }}>
                                                        <i className="ri-add-line align-bottom me-1"></i> Add
                                                        Topic Area
                                                    </button>{" "}
                                                </AuthorizeForAction>
                                            </div>
                                        </div>
                                    </Row>
                                </CardHeader>
                                <div className="card-body pt-0">
                                    {(loading ?
                                        <React.Fragment>
                                            <div className="d-flex justify-content-center mx-2 mt-2">
                                                <Spinner color="primary"> Loading... </Spinner>
                                            </div>
                                            {/*{toast.error(props.error, { position: "top-right", hideProgressBar: false, progress: undefined, toastId: "" })}*/}
                                        </React.Fragment>
                                        : <div>
                                            {isTopicAreaSuccess && topicAreas.length ? (
                                                <TableContainer
                                                    columns={columns}
                                                    data={(topicAreas || [])}
                                                    isGlobalFilter={true}
                                                    isAddUserList={false}
                                                    customPageSize={8}
                                                    className="custom-header-css"
                                                    handleCustomerClick={handleCustomerClicks}
                                                    isCustomerFilter={false}
                                                    SearchPlaceholder='Search for Topic Area, status or something...'
                                                />
                                            ) : (
                                                <div className="py-4 text-center">
                                                    <div>
                                                        <lord-icon
                                                            src="https://cdn.lordicon.com/msoeawqm.json"
                                                            trigger="loop"
                                                            colors="primary:#405189,secondary:#0ab39c"
                                                            style={{ width: "72px", height: "72px" }}
                                                        ></lord-icon>
                                                    </div>

                                                    <div className="mt-4">
                                                        <h5>Sorry! No Record Found</h5>
                                                    </div>
                                                </div>)}
                                        </div>)}
                                    <Modal id="showModal" backdrop="static" isOpen={modal} toggle={toggle} centered>
                                        <ModalHeader className="bg-light p-3" toggle={toggle}>

                                            {!!isEdit ? "Edit Topic Area" : "Add Topic Area"}

                                        </ModalHeader>
                                        <Form className="tablelist-form" onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}>
                                            <ModalBody>
                                                <input type="hidden" id="id-field" />

                                                <div
                                                    className="mb-3"
                                                    id="modal-id"
                                                    style={{ display: "none" }}
                                                >
                                                    <Label htmlFor="id-field1" className="form-label">

                                                    </Label>
                                                    <Input
                                                        type="text"
                                                        id="id-field1"
                                                        className="form-control"
                                                        placeholder="ID"
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="mb-3">
                                                    <Label
                                                        htmlFor="title-field"
                                                        className="form-label"
                                                    >
                                                        Topic Title
                                                    </Label>
                                                    <Input
                                                        name="full_name"
                                                        id="name-field"
                                                        className="form-control"
                                                        placeholder="Enter full name"
                                                        type="text"
                                                        validate={{
                                                            required: { value: true },
                                                        }}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.full_name || ""}
                                                        invalid={
                                                            validation.touched.full_name && validation.errors.full_name ? true : false
                                                        }
                                                    />
                                                    {validation.touched.full_name && validation.errors.full_name ? (
                                                        <FormFeedback type="invalid">{validation.errors.full_name}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="status-field" className="form-label">
                                                        Status
                                                    </Label>
                                                    <Input
                                                        name="status"
                                                        type="select"
                                                        className="form-select"
                                                        id="status-field"
                                                        onChange={validation.handleChange}
                                                        validate={{
                                                            required: { value: true },
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={
                                                            validation.values.status || ""
                                                        }
                                                        invalid={
                                                            validation.touched.status && validation.errors.status ? true : false
                                                        }
                                                    >
                                                        {courseStatus.map((item, key) => (
                                                            <React.Fragment key={key}>
                                                                {item.options.map((item, key) => (<option value={item.value} key={key}>{item.label}</option>))}
                                                            </React.Fragment>
                                                        ))}

                                                    </Input>
                                                    {validation.touched.status &&
                                                        validation.errors.status ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.status}
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>
                                            </ModalBody>
                                            <ModalFooter>
                                                <div className="hstack gap-2 justify-content-end">
                                                    <button type="button" className="btn btn-light" onClick={() => { setModal(false); validation.resetForm(); }}> Close </button>

                                                    <Button color="success" disabled={isloading ? true : false} className="btn-load" type="submit">
                                                        <span className="d-flex align-items-center">
                                                            {isloading ? <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner> : null}
                                                            <span className="flex-grow-1 ms-2">
                                                                {!!isEdit ? "Update" : "Add Topic Area"}{" "}
                                                            </span>
                                                        </span>
                                                    </Button>
                                                </div>
                                            </ModalFooter>
                                        </Form>
                                    </Modal>
                                    <Modal id="showModal" backdrop="static" isOpen={translationModal} centered>
                                        <ModalHeader className="bg-light p-3" >
                                            Topic Area Translation - <span id="translationTitle">{defualtTranslation.full_name}</span>
                                        </ModalHeader>
                                        <Form className="tablelist-form" onSubmit={(e) => {
                                            e.preventDefault();
                                            validationTrans.handleSubmit();
                                            return false;
                                        }}>
                                            <ModalBody>
                                                <div className="row">
                                                    <Input type="hidden" name="t_topic_area_id"
                                                        value={validationTrans.values.t_topic_area_id || topicArea.id} />
                                                    <div className="col-lg-3">
                                                        <div className="nav nav-pills flex-column nav-pills-tab custom-verti-nav-pills text-center " role="tablist" aria-orientation="vertical" id="course-nav-section">
                                                            {lang.map((language, key) => (
                                                                <a key={key}
                                                                    onClick={() => handleTabClick(key)}
                                                                    className={`nav-link ${key === activeIndex ? 'active' : ''}`} id={"custom-v-pills-profile-tab-" + language.lang_short} data-bs-toggle="pill" role="tab" aria-controls="custom-v-pills-profile" aria-selected="false" tabIndex={key} >{language.lang}</a>
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-9">
                                                        <div className="tab-content text-muted mt-3 mt-lg-0" id="course-translation-section">

                                                            {lang.map((language, key) => (

                                                                <div key={key} className={key === activeIndex ? "tab-pane fade active show" : "tab-pane fade "} id={"custom-v-pills-profile-" + language.lang_short} role="tabpanel" aria-labelledby={"custom-v-pills-profile-tab-" + language.lang_short}>
                                                                    <div className="mb-4">
                                                                        <Input type="hidden" name="t_lang[]"
                                                                            value={language.lang_short} />
                                                                        <div className="mb-3">
                                                                            <label htmlFor="fullName" className="form-label">Topic Area Title </label>
                                                                            <Input
                                                                                name="t_full_name[]"
                                                                                id="fullName"
                                                                                className="form-control"
                                                                                placeholder="Enter topic area title"
                                                                                type="text"
                                                                                dir={language.direction == 2 ? "ltr" : "rtl"}
                                                                                onBlur={validationTrans.handleBlur}
                                                                                onChange={(e) => handleInputChange(key, e.target.value)}
                                                                                value={validationTrans.values.t_full_name[key] ? validationTrans.values.t_full_name[key] : defualtTranslation.full_name || ""}
                                                                            />

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                            </ModalBody>
                                            <ModalFooter>
                                                <div className="hstack gap-2 justify-content-end">
                                                    <button type="button" className="btn btn-light" onClick={() => { setTranslationModal(false); validation.resetForm() }}> Close </button>
                                                    <Button color="success" disabled={isloading ? true : false} className="btn-load" type="submit">
                                                        <span className="d-flex align-items-center">
                                                            {isloading ? <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner> : null}
                                                            <span className="flex-grow-1 ms-2">
                                                                Save Changes
                                                            </span>
                                                        </span>
                                                    </Button>
                                                </div>
                                            </ModalFooter>
                                        </Form>
                                    </Modal>
                                    <ToastContainer closeButton={false} limit={1} />
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}
export default TopicArea;